import { render, staticRenderFns } from "./GenericContentDuplicationsModal.vue?vue&type=template&id=65ef2602&scoped=true"
import script from "./GenericContentDuplicationsModal.vue?vue&type=script&lang=js"
export * from "./GenericContentDuplicationsModal.vue?vue&type=script&lang=js"
import style0 from "./GenericContentDuplicationsModal.vue?vue&type=style&index=0&id=65ef2602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ef2602",
  null
  
)

export default component.exports